import React, { useState } from 'react';
import Search from 'src/assets/images/Search.svg';
import ModalClose from 'src/assets/images/ModalClose.svg';
import { getInventoryDetails } from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    SearchBoxContainer,
    StyledInput,
    IconContainer,
    ClearIconContainer,
    SearchWarning,
} from './HighlightSearch.styled';

const HighlightSearch = ({ cursor, setSearchItem, setShowBtn }) => {
    const [showWarning, setShowWarning] = useState(false);
    const [ShowCloseIcon, setShowCloseIcon] = useState(false);
    const accountId = useSelector(
        (state) => state.consignmentReducer.surgeryDetails.accountId.accountId
    );
    const { isShortTermConsignment } = useSelector((state) => ({
        isShortTermConsignment:
            state.consignmentReducer.surgeryDetails.isShortTermConsignment,
    }));
    const { countryISOCode, specialStockPartner } = useSelector((state) => ({
        countryISOCode: state.loginReducer?.hybrisUserDetails.countryISOCode,
        specialStockPartner:
            state.consignmentReducer.surgeryDetails.specialStockPartnerDetails
    }));
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const searchHandler = (e) => {
        setInputValue(e.target.value);
        if (e.target.value.length < 3 && e.target.value != '') {
            setShowWarning(true);
        } else {
            setShowWarning(false);
            setShowBtn(true);
            setSearchItem(e.target.value);
            const payload = {
                accountNumber:
                //specialStockPartnerVisibilityKE === 'VISIBLE' && 
                specialStockPartner
                        ? specialStockPartner?.sbNumber
                        : accountId,
                productType: 'tissue',
                orderType: 'KE',
                resourceType: 'INVENTORY_LIST',
                sortCode: 'cfn',
                sortOrder: 'ASC',
                currentPage: '0',
                filterParam: 'all',
                searchQuery: e.target.value,
                pageSize: '50',
                isBKPProductsDisplay: isShortTermConsignment ? true : false,
            };
            dispatch(getInventoryDetails(payload));
        }
        if (e.target.value.length > 0) {
            setShowCloseIcon(true);
        } else {
            setShowCloseIcon(false);
        }
    };
    const clearSearch = () => {
        setShowCloseIcon(false);
        setInputValue('');
        setShowWarning(false);
        setSearchItem('');
        const payload = {
            accountNumber:
            //specialStockPartnerVisibilityKE === 'VISIBLE' && 
            specialStockPartner
                    ? specialStockPartner?.sbNumber
                    : accountId,
            productType: 'tissue',
            orderType: 'KE',
            resourceType: 'INVENTORY_LIST',
            sortCode: 'cfn',
            sortOrder: 'ASC',
            currentPage: '0',
            filterParam: 'all',
            searchQuery: '',
            pageSize: '50',
            isBKPProductsDisplay: isShortTermConsignment ? true : false,
        };
        dispatch(getInventoryDetails(payload));
    };
    return (
        <>
            <SearchBoxContainer width={'382px'}>
                <IconContainer
                    width={'19px'}
                    height={'19px'}
                    mobileWidth={'19px'}
                    mobileHeight={'19px'}
                >
                    <img
                        src={Search}
                        alt={'Search Icon'}
                        width={'18px'}
                        height={'18px'}
                    />
                </IconContainer>
                <StyledInput
                    id="search"
                    type="text"
                    searchImg={Search}
                    value={inputValue}
                    placeholder={t(
                        'consignmentBilling.inventory.enterProductNoKeyword'
                    )}
                    onChange={(e) => searchHandler(e)}
                    autoComplete="off"
                    fontSize={'13px'}
                />
                {ShowCloseIcon && (
                    <ClearIconContainer id={`consignmentBilling-highlightSearch-clearIconContainer-${accountId || 'default'}`} onClick={clearSearch} cursor={cursor}>
                        <img
                            src={ModalClose}
                            alt={'clearSearch'}
                            width="12px"
                            height="12px"
                        />
                    </ClearIconContainer>
                )}
            </SearchBoxContainer>
            <SearchWarning>
                {showWarning
                    ? t(
                          'consignmentBilling.inventory.enter3numbersToSeeResults'
                      )
                    : ''}
            </SearchWarning>
        </>
    );
};

export default HighlightSearch;
